import { ca } from '@cian/analytics';

import { rubricToAnalyticsCategory } from '../../hooks/useDropdownLinks/useBottomLinks/utils';
import { getAnaliticName } from '../../hooks/useDropdownLinks/utils/getAnaliticName';
import { ERubric } from '../../types/rubricsLinks';

export function trackNavBarClick(rubric: ERubric, url?: string) {
  const category = rubricToAnalyticsCategory(rubric);
  const label = getAnaliticName(rubric, url);

  ca('eventSite', {
    name: 'oldevent',
    category,
    action: 'top_menu',
    label,
  });
}
